module.exports = __webpack_public_path__ + "img/zx2.322f48aa.png";